import * as yup from 'yup';
import { passwordSchema } from '../../../utils/validation';

const rules = yup.object({
  password: passwordSchema(),
});

export default rules;
